import React from 'react';
import {withRouter} from "components/router/withRouter";
import {launchDarkly} from "utils/launchDarkly.ts";
import {OldPreApproval} from "components/preapproval/OldPreApproval.component.jsx";
import NewPreApproval from "components/preapproval/NewPreApproval.component.tsx";

function PreApproval(props) {
    const usAutopayRedirect = launchDarkly.userClient?.variation("fe-redirect-to-autopay", false);

    return usAutopayRedirect ? <NewPreApproval {...props}/> : <OldPreApproval {...props}/>;
}

export default withRouter(PreApproval);